var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ms-text"},[_vm._v("\n    "+_vm._s(_vm.roadmap.name)+"\n  ")]),(_vm.roadmap.parent_roadmap_id)?_c('div',{staticClass:"ms-help"},[_vm._v("\n    "+_vm._s(_vm.roadmap.parent_roadmap_id
        ? `${_vm.roadmap.parent_roadmap_number}. ${_vm.roadmap.parent_roadmap_name}`
        : "Не привязан к этапу родительского договора")+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }